import 'vite/modulepreload-polyfill'
import '../Css/index.css';
import alpine from "alpinejs";
import './Components/BibleVerses/bible-verses';


// Exports to window.BST

// Utility
import {default as JSCookies} from './Utility/js-cookie';
import {default as SiteStorage} from './Utility/site-cookies';
import {default as ScrollLock} from './Utility/scroll-lock'
import {default as Clipboard} from './Utility/clipboard'

// Components
import {default as UserNotes} from './Components/BibleSidebar/user-notes'
import {default as UserHighlights} from './Components/BibleSidebar/user-highlights'
import {default as UserBookmarks} from './Components/BibleSidebar/user-bookmarks'
import {default as UserReadingPlan} from './Components/BibleSidebar/user-reading-plan'
import {default as ParallelBibleTranslationSelector} from
        './Components/ParallelBibleTranslationSelector/parallel-bible-translation-selector'
import {default as BibleTranslationSelector} from './Components/BibleTranslationSelector/bible-translation-selector'
import {default as BibleChapterSelector} from './Components/BibleChapterSelector/bible-chapter-selector'
import {default as BibleVerses} from './Components/BibleVerses/bible-verses'
import {default as ConfirmationDialog} from './Components/ConfirmationDialog/confirmation-dialog'
import {default as AudioBiblePlayer} from './Components/AudioBiblePlayer/audio-bible-player'
import {default as AudioBookPlayer} from './Components/AudioBookPlayer/audio-book-player'
import {default as ReferenceLibrary} from './Components/ReferenceLibrary/reference-library'
import {default as TranslationsSelector} from './Components/TranslationsSelector/bible-translation-selector'
import {default as VerseOfTheDayBrowser} from './Components/VerseOfTheDayBrowser/verse-of-the-day-browser'
import {default as BibleBrowse} from './Components/BibleBrowse/bible-browse'

// Pelcro
import { default as Pelcro } from './Pelcro'

// Zeta
import {default as Zeta} from './Zeta'

// Admiral AdBlockBlock
import {default as Admiral} from './Admiral'

window.BST = {
    JSCookies,
    SiteStorage,
    ScrollLock,
    Clipboard,
    UserNotes,
    UserHighlights,
    UserBookmarks,
    UserReadingPlan,
    ParallelBibleTranslationSelector,
    BibleTranslationSelector,
    BibleChapterSelector,
    BibleVerses,
    ConfirmationDialog,
    AudioBiblePlayer,
    AudioBookPlayer,
    ReferenceLibrary,
    TranslationsSelector,
    VerseOfTheDayBrowser,
    BibleBrowse,
    // Piano,
    Pelcro,
    Zeta,
    Admiral
};

alpine.start()